export default __webpack_public_path__ + "static/media/ICON19.08a6d27d.svg";